import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type OpportunityModalStore } from 'pages/settings/pages/billing/pages/overview/ui/OpportunityModal/store/opportunityModalStore'
import styles from './styles.module.scss'

export const GetCallModalActions = observer(({ store }: { store: OpportunityModalStore }) => {
  const { isLoading, handleBack, handleSave, phoneInputStore } = store

  const isPhoneNumberValid =
    phoneInputStore.isValidNumber && phoneInputStore.number.trim().length > 0
  const isDisabled = isLoading || !isPhoneNumberValid

  return (
    <div className={styles.actions}>
      <Button
        text='Back'
        typeBtn='contained'
        contained='secondary'
        size='medium'
        onClick={handleBack}
        loading={isLoading}
        disabled={isLoading}
      />
      <Button
        text='Request call'
        typeBtn='contained'
        contained='primary'
        size='medium'
        onClick={handleSave}
        disabled={isDisabled}
        loading={isLoading}
      />
    </div>
  )
})
